import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './style.css';
import { ReactMic } from 'react-mic';
import { useNavigate } from "react-router-dom";
import IconNora from "../../images/nora-icon.png";
import LeftArrow from "../../images/homepage/arrow-left.svg";
import { Oval } from 'react-loader-spinner'; 
import { AssemblyAI } from 'assemblyai';
import { getToken } from '../../authetication/loginState';
import ErrorIcon from "../../images/error-icon.png";
import Box from '@mui/material/Box';
import Modal from "@material-ui/core/Modal";
import { useMediaQuery } from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import * as Sentry from '@sentry/react';
import InterviewCard1 from "../../images/interviewCard1.png";
import InterviewCard2 from "../../images/interviewCard2.png";
import InterviewCard3 from "../../images/interviewCard3.png";
import InterviewCard4 from "../../images/interviewCard4.png";
import NoraZoom from "../../images/nora-zoom.png";
import ExclamationIcon from "../../images/exclamationIcon2.png";
import DailyIframe from '@daily-co/daily-js';
import VideoRecorderIcon from '../../images/video-recorder.png';
import AudioRecorderIcon from '../../images/microphone-01.png';
import FeedbackLoader from '../FeedbackLoader';

const NoraForm = () => {
  const [started, setStarted] = useState(false);
  const [testing, setTesting] = useState(false);
  const [history, setHistory] = useState([]);
  const [record, setRecord] = useState(false);
  const [time, setTime] = useState(0);
  const videoRef = useRef(null);
  const messageEndRef = useRef(null);
  const saveTimeoutRef = useRef(null);
  const [feedbackLoading, setFeedbackLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isNoraSpeaking, setIsNoraSpeaking] = useState(false);
  const [isInterviewDone, setInterviewDone] = useState(false);
  const [aiResponse, setAiResponse] = useState('');
  const [hasError, setHasError] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openTest, setOpenTest] = useState(false);
  const [screenStep, setScreenStep] = useState(1);
  const [showEndModal, setShowEndModal] = useState(false);
  const [stripeLoaded, setStripeLoaded] = useState(false);
  const [checkout, setCheckout] = useState(null);
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
  const [checkoutError, setCheckoutError] = useState('');
  const [selectedPlan, setSelectedPlan] = useState('annual');
  
  // Testing screen state
  const [audioPermissionGranted, setAudioPermissionGranted] = useState(false);
  const [videoPermissionGranted, setVideoPermissionGranted] = useState(false);
  const [previewStream, setPreviewStream] = useState(null);
  const [permissionError, setPermissionError] = useState('');
  const [availableVideoDevices, setAvailableVideoDevices] = useState([]);
  const [availableAudioDevices, setAvailableAudioDevices] = useState([]);
  const [selectedVideoDeviceId, setSelectedVideoDeviceId] = useState('');
  const [selectedAudioDeviceId, setSelectedAudioDeviceId] = useState('');
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [permissionsBrowserTab, setPermissionsBrowserTab] = useState('chrome');
  const previewVideoRef = useRef(null);
 
  const position = localStorage.getItem("position");
  const jobDescription = localStorage.getItem("jobDescription");
  const companyName = localStorage.getItem("companyName");
  const technicalLevel = localStorage.getItem("technicalLevel");
  const userEmail = localStorage.getItem("userEmail");
  const salaryRange = localStorage.getItem("salaryRange");
  const currency = localStorage.getItem("currency");
  const location = localStorage.getItem("location");
  const companyData = localStorage.getItem("companyData");
  const [lastNoraQuestion, setLastNoraQuestion] = useState('');
  const [previousNoraQuestion, setPreviousNoraQuestion] = useState('');
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [showMobileWarningModal, setShowMobileWarningModal] = useState(false);

  // DAILY.CO INTEGRATION - NEW STATE
  const callObjectRef = useRef(null);
  const [roomInfo, setRoomInfo] = useState(null);
  const [isDailyRecording, setIsDailyRecording] = useState(false);
  const [dailyJoined, setDailyJoined] = useState(false);
  const dailyListenersAttached = useRef(false);
  const audioContextRef = useRef(null);
  const audioDestinationRef = useRef(null);
  const noraAudioRef = useRef(null);
  const noraSourceRef = useRef(null);
  const dailyAudioInputStreamRef = useRef(null);
  const dailyMicSourceRef = useRef(null);
  const [showAnswerForMe, setShowAnswerForMe] = useState(false);
  const answerForMeTimerRef = useRef(null);

  useEffect(() => {
    // Clear any existing timer
    if (answerForMeTimerRef.current) {
      clearTimeout(answerForMeTimerRef.current);
      answerForMeTimerRef.current = null;
    }
    
    setShowAnswerForMe(false);

    // Start timer only when Nora is done speaking and user hasn't started recording
    if (!isNoraSpeaking && !isLoading && !record && !isInterviewDone && lastNoraQuestion) {
      answerForMeTimerRef.current = setTimeout(() => {
        setShowAnswerForMe(true);
      }, 10000);
    }

    return () => {
      if (answerForMeTimerRef.current) {
        clearTimeout(answerForMeTimerRef.current);
      }
    };
  }, [isNoraSpeaking, isLoading, record, isInterviewDone, lastNoraQuestion]);

  const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet';
    }
    if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return 'mobile';
    }
    return 'desktop';
  };

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isIPad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;

  const isSafari = () => {
    const ua = navigator.userAgent;
    return ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Chromium');
  };

  // Permission checking functions for testing screen
  const getAvailableDevices = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');
      const audioDevices = devices.filter(device => device.kind === 'audioinput');
      
      setAvailableVideoDevices(videoDevices);
      setAvailableAudioDevices(audioDevices);
      
      if (!selectedVideoDeviceId && videoDevices.length > 0) {
        setSelectedVideoDeviceId(videoDevices[0].deviceId);
      }
      if (!selectedAudioDeviceId && audioDevices.length > 0) {
        setSelectedAudioDeviceId(audioDevices[0].deviceId);
      }
    } catch (error) {
      console.error('Error enumerating devices:', error);
    }
  };

  const checkPermissions = async () => {
    setPermissionError('');
    try {
      const tempStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      tempStream.getTracks().forEach(track => track.stop());
      
      await getAvailableDevices();
      
      const constraints = {
        video: selectedVideoDeviceId ? { deviceId: { exact: selectedVideoDeviceId } } : true,
        audio: selectedAudioDeviceId ? { deviceId: { exact: selectedAudioDeviceId } } : true,
      };
      
      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      const videoTracks = stream.getVideoTracks();
      const audioTracks = stream.getAudioTracks();

      const hasVideo = videoTracks.length > 0 && videoTracks[0].enabled;
      const hasAudio = audioTracks.length > 0 && audioTracks[0].enabled;

      setVideoPermissionGranted(hasVideo);
      setAudioPermissionGranted(hasAudio);

      if (hasVideo && hasAudio) {
        setPreviewStream(stream);
        if (previewVideoRef.current) {
          previewVideoRef.current.srcObject = stream;
        }
      } else {
        stream.getTracks().forEach(track => track.stop());
        setPreviewStream(null);
        
        if (!hasVideo && !hasAudio) {
          setPermissionError('Both camera and microphone access are required to conduct the interview.');
        } else if (!hasVideo) {
          setPermissionError('Camera access is required to conduct the interview.');
        } else if (!hasAudio) {
          setPermissionError('Microphone access is required to conduct the interview.');
        }
      }

      return hasVideo && hasAudio;
    } catch (error) {
      console.error('Error accessing media devices:', error);
      setVideoPermissionGranted(false);
      setAudioPermissionGranted(false);
      setPreviewStream(null);
      
      if (error.name === 'NotAllowedError') {
        setPermissionError('Camera and microphone access denied. Please allow access and refresh the page.');
      } else if (error.name === 'NotFoundError') {
        setPermissionError('No camera or microphone found. Please ensure your devices are connected.');
      } else {
        setPermissionError('Unable to access camera or microphone. Please check your device settings.');
      }
      
      return false;
    }
  };

  const handleDeviceChange = async (deviceId, deviceType) => {
    if (deviceType === 'video') {
      setSelectedVideoDeviceId(deviceId);
    } else if (deviceType === 'audio') {
      setSelectedAudioDeviceId(deviceId);
    }
    
    if (videoPermissionGranted && audioPermissionGranted) {
      try {
        if (previewStream) {
          previewStream.getTracks().forEach(track => track.stop());
        }
        
        const constraints = {
          video: deviceType === 'video' ? { deviceId: { exact: deviceId } } : 
                 selectedVideoDeviceId ? { deviceId: { exact: selectedVideoDeviceId } } : true,
          audio: deviceType === 'audio' ? { deviceId: { exact: deviceId } } :
                 selectedAudioDeviceId ? { deviceId: { exact: selectedAudioDeviceId } } : true,
        };
        
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        setPreviewStream(stream);
        
        if (previewVideoRef.current) {
          previewVideoRef.current.srcObject = stream;
        }
      } catch (error) {
        console.error('Error switching device:', error);
      }
    }
  };

  const stopPreviewStream = () => {
    if (previewStream) {
      previewStream.getTracks().forEach(track => track.stop());
      setPreviewStream(null);
    }
    if (previewVideoRef.current) {
      previewVideoRef.current.srcObject = null;
    }
  };

  const permissionsReady = audioPermissionGranted && videoPermissionGranted;

  const permissionsGuides = {
    chrome: {
      title: 'Google Chrome needs your permission to access your camera and microphone.',
      sections: [
        {
          heading: 'Method 1: Using the address bar',
          steps: [
            'Look for the camera/microphone icon in the address bar (left side).',
            'Click on the icon.',
            'Select "Always allow" for camera and microphone.',
            'Click "Done" and refresh the page.'
          ]
        },
        {
          heading: 'Method 2: Using Chrome settings',
          steps: [
            'Click the three dots menu (vertical ellipsis) in the top-right corner.',
            'Go to Settings -> Privacy and security -> Site settings.',
            'Click on "Camera" and "Microphone".',
            'Make sure they are not blocked for this site.',
            'Refresh the page.'
          ]
        }
      ],
      footer: 'After enabling permissions, you may need to refresh this page for changes to take effect.'
    },
    safari: {
      title: 'Safari needs your permission to access your camera and microphone.',
      sections: [
        {
          heading: 'For macOS',
          steps: [
            'In Safari, go to Safari menu -> Settings (or Preferences).',
            'Click on the "Websites" tab.',
            'Select "Camera" and "Microphone" from the left sidebar.',
            'Find this website in the list and set to "Allow".',
            'Close settings and refresh the page.'
          ]
        },
        {
          heading: 'For iOS (iPhone/iPad)',
          steps: [
            'Open the Settings app on your device.',
            'Scroll down and tap Safari.',
            'Tap on "Camera" and select "Allow".',
            'Tap on "Microphone" and select "Allow".',
            'Return to Safari and refresh the page.'
          ]
        }
      ],
      footer: 'After enabling permissions, you may need to refresh this page for changes to take effect.'
    }
  };

  // DAILY.CO FUNCTIONS - START
  const initNoraAudioGraph = async () => {
    if (!audioContextRef.current || audioContextRef.current.state === 'closed') {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioContextRef.current.state === 'suspended') {
      try { await audioContextRef.current.resume(); } catch {}
    }

    if (!audioDestinationRef.current || audioDestinationRef.current.context !== audioContextRef.current) {
      audioDestinationRef.current = audioContextRef.current.createMediaStreamDestination();
    }

    if (!noraAudioRef.current) {
      const el = new Audio();
      el.setAttribute('playsinline', 'true');
      el.muted = false;
      noraAudioRef.current = el;
    }

    if (!noraSourceRef.current || noraSourceRef.current.context !== audioContextRef.current) {
      try {
        try { noraSourceRef.current?.disconnect(); } catch {}
        noraSourceRef.current = audioContextRef.current.createMediaElementSource(noraAudioRef.current);
        noraSourceRef.current.connect(audioContextRef.current.destination);
        if (!isIOS && audioDestinationRef.current) {
          noraSourceRef.current.connect(audioDestinationRef.current);
        }
      } catch (e) {
        try { noraSourceRef.current?.disconnect(); } catch {}
        noraSourceRef.current = audioContextRef.current.createMediaElementSource(noraAudioRef.current);
        noraSourceRef.current.connect(audioContextRef.current.destination);
        if (!isIOS && audioDestinationRef.current) {
          noraSourceRef.current.connect(audioDestinationRef.current);
        }
      }
    }
  };

  const getDailyMixedAudioStream = async () => {
    try {
      await initNoraAudioGraph();

      if (!dailyAudioInputStreamRef.current) {
        dailyAudioInputStreamRef.current = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false
        });
      }

      if (!dailyMicSourceRef.current && audioContextRef.current && audioDestinationRef.current) {
        dailyMicSourceRef.current = audioContextRef.current.createMediaStreamSource(
          dailyAudioInputStreamRef.current
        );
        dailyMicSourceRef.current.connect(audioDestinationRef.current);
      }

      return audioDestinationRef.current?.stream || null;
    } catch (error) {
      console.error('Failed to prepare Daily mixed audio stream:', error);
      return null;
    }
  };

  const createDailyRoom = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/Chat/createMockInterviewRoom`,
        { 
          userEmail: userEmail,
          timestamp: Date.now()
        },
        { 
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getToken()}`
          } 
        }
      );
      return response.data;
    } catch (error) {
      console.error('Failed to create Daily room:', error);
      Sentry.captureException(error, {
        extra: { message: "Failed to create Daily room for mock interview", userEmail }
      });
      throw error;
    }
  };

  const joinDailyRoom = async (roomUrl) => {
    try {
      if (!callObjectRef.current) {
        callObjectRef.current = DailyIframe.createCallObject();
      }

      if (!dailyListenersAttached.current) {
        callObjectRef.current.on('track-started', (event) => {
          if (event.participant.local && event.track.kind === 'video') {
            if (videoRef.current) {
              videoRef.current.srcObject = new MediaStream([event.track]);
            }
          }
        });

        callObjectRef.current.on('joined-meeting', async () => {
          setDailyJoined(true);
          console.log('✅ Joined Daily room');
          
          if (isSafari()) {
            try {
              await callObjectRef.current.setLocalAudio(true);
              const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
              await callObjectRef.current.setInputDevicesAsync({
                audioDeviceId: stream.getAudioTracks()[0]?.getSettings()?.deviceId || 'default'
              });
              stream.getTracks().forEach(track => track.stop());
            } catch (safariError) {
              console.warn('Safari audio fix failed:', safariError);
            }
          }
        });

        callObjectRef.current.on('recording-started', () => {
          setIsDailyRecording(true);
          console.log('✅ Daily recording started');
          
          if (isSafari()) {
            setTimeout(async () => {
              try {
                await callObjectRef.current.setLocalAudio(true);
              } catch (err) {
                console.warn('Safari audio re-enable failed:', err);
              }
            }, 1000);
          }
        });

        callObjectRef.current.on('recording-stopped', () => {
          setIsDailyRecording(false);
          console.log('⏹️ Daily recording stopped');
        });

        callObjectRef.current.on('error', (error) => {
          console.error('Daily error:', error);
        });

        dailyListenersAttached.current = true;
      }

      if (!dailyJoined) {
        await callObjectRef.current.join({ 
          url: roomUrl,
          userName: userEmail || 'Mock Interview User',
          audioSource: true,
          videoSource: true
        });

        const mixedAudioStream = await getDailyMixedAudioStream();
        const mixedAudioTrack = mixedAudioStream?.getAudioTracks?.()?.[0];
        if (mixedAudioTrack) {
          try {
            await callObjectRef.current.setInputDevicesAsync({ audioSource: mixedAudioTrack });
          } catch (setAudioErr) {
            console.warn('Could not set mixed audio source for Daily:', setAudioErr);
          }
        }
      }
    } catch (error) {
      console.error('Failed to join Daily room:', error);
      Sentry.captureException(error, {
        extra: { message: "Failed to join Daily room", roomUrl }
      });
      throw error;
    }
  };

  const startDailyRecording = async () => {
    if (callObjectRef.current) {
      try {
        if (isSafari()) {
          await callObjectRef.current.setLocalAudio(true);
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        await callObjectRef.current.startRecording();
        console.log('🔴 Started Daily recording');
      } catch (error) {
        console.error('Failed to start Daily recording:', error);
        Sentry.captureException(error, {
          extra: { userEmail, roomName: roomInfo?.roomName }
        });
      }
    }
  };

  const stopDailyRecording = async () => {
    if (callObjectRef.current) {
      try {
        await callObjectRef.current.stopRecording();
        console.log('⏹️ Stopped Daily recording');
      } catch (error) {
        console.error('Failed to stop Daily recording:', error);
      }
    }
  };

  const leaveDailyRoom = async () => {
    if (callObjectRef.current) {
      try {
        await callObjectRef.current.leave();
        await callObjectRef.current.destroy();
        callObjectRef.current = null;
        setDailyJoined(false);
        dailyListenersAttached.current = false;
        console.log('👋 Left Daily room');

        try { dailyMicSourceRef.current?.disconnect(); } catch {}
        dailyMicSourceRef.current = null;
        if (dailyAudioInputStreamRef.current) {
          dailyAudioInputStreamRef.current.getTracks().forEach(track => track.stop());
          dailyAudioInputStreamRef.current = null;
        }
      } catch (error) {
        console.error('Failed to leave Daily room:', error);
      }
    }
  };

  const getDailyRecording = async (roomName) => {
    try {
      let attempts = 0;
      const maxAttempts = 60;
      console.log(`🎬 Starting recording fetch for room: ${roomName}`);

      while (attempts < maxAttempts) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_ENDPOINT}/api/Daily/getDailyRecording`,
          { roomName },
          { 
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${getToken()}`
            } 
          }
        );

        const data = response.data;
        
        if (data.status === 'finished' && data.downloadUrl) {
          console.log('✅ Recording ready:', data.downloadUrl);
          return data.downloadUrl;
        }
        
        if (data.status === 'failed' || data.status === 'error') {
          throw new Error(`Recording processing failed with status: ${data.status}`);
        }

        console.log(`⏳ Recording processing... (attempt ${attempts + 1}/${maxAttempts})`);
        await new Promise(resolve => setTimeout(resolve, 5000));
        attempts++;
      }

      throw new Error('Recording processing timeout');
    } catch (error) {
      console.error('Failed to get Daily recording:', error);
      throw error;
    }
  };
  // DAILY.CO FUNCTIONS - END

  const handleEndInterviewClick = () => {
    if (history.some((msg) => msg.message.includes("End of the interview"))) {
      handleEndInterview(); // Direct end if interview naturally concluded
    } else {
      setShowEndModal(true); // Show confirmation modal
    }
  };

  const handleConfirmEnd = () => {
    setShowEndModal(false);
    handleEndInterview(); // Trigger actual end interview logic
  };

  const handleCancelEnd = () => {
    setShowEndModal(false); // Close the modal and continue interview
  };

  const generateSessionId = () => {
    return `${userEmail}_${position}_${Date.now()}`.replace(/[^a-zA-Z0-9_]/g, '_');
  };

  const findMostRecentSession = () => {
    if (!userEmail || !position || !technicalLevel) return null;
    
    let mostRecentKey = null;
    let mostRecentTimestamp = 0;
    
    try {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('interviewState_')) {
          try {
            const state = JSON.parse(localStorage.getItem(key));
            if (state.userEmail === userEmail && 
                state.position === position && 
                state.technicalLevel === technicalLevel &&
                state.timestamp > mostRecentTimestamp) {
              mostRecentKey = key;
              mostRecentTimestamp = state.timestamp;
            }
          } catch (error) {
            localStorage.removeItem(key);
          }
        }
      });
    } catch (error) {
      console.error('Error finding recent session:', error);
    }
    
    return mostRecentKey;
  };

  const getSessionKey = () => {
    let sessionId = sessionStorage.getItem('currentInterviewSessionId');
    
    if (!sessionId) {
      const existingSessionKey = findMostRecentSession();
      if (existingSessionKey) {
        sessionId = existingSessionKey.replace('interviewState_', '');
        sessionStorage.setItem('currentInterviewSessionId', sessionId);
        return existingSessionKey;
      } else {
        sessionId = generateSessionId();
        sessionStorage.setItem('currentInterviewSessionId', sessionId);
      }
    }
    
    return `interviewState_${sessionId}`;
  };

  const debouncedSave = (state) => {
    clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(() => {
      try {
        saveInterviewState(state);
      } catch (error) {
        console.error('Failed to save interview state:', error);
      }
    }, 500);
  };

  const saveInterviewState = (state) => {
    try {
      const sessionKey = getSessionKey();
      const interviewState = {
        started: state.started,
        history: state.history,
        time: state.time,
        screenStep: state.screenStep || 1,
        isInterviewDone: state.isInterviewDone || false,
        lastNoraQuestion: state.lastNoraQuestion || '',
        previousNoraQuestion: state.previousNoraQuestion || '',
        sessionId: sessionKey,
        userEmail: userEmail,
        position: position,
        technicalLevel: technicalLevel,
        timestamp: Date.now()
      };
      
      localStorage.setItem(sessionKey, JSON.stringify(interviewState));
      cleanupOldSessions();
    } catch (error) {
      console.error('Failed to save to localStorage:', error);
    }
  };

  const loadInterviewState = () => {
    try {
      const sessionKey = getSessionKey();
      const saved = localStorage.getItem(sessionKey);
      if (!saved) return null;
      
      const state = JSON.parse(saved);
      
      if (state.userEmail !== userEmail || 
          state.position !== position || 
          state.technicalLevel !== technicalLevel) {
        localStorage.removeItem(sessionKey);
        return null;
      }
      
      const twoHours = 2 * 60 * 60 * 1000;
      if (Date.now() - state.timestamp > twoHours) {
        localStorage.removeItem(sessionKey);
        return null;
      }
      
      return state;
    } catch (error) {
      console.error('Error loading interview state:', error);
      return null;
    }
  };

  const clearInterviewState = () => {
    try {
      const sessionKey = getSessionKey();
      localStorage.removeItem(sessionKey);
      sessionStorage.removeItem('currentInterviewSessionId');
      clearTimeout(saveTimeoutRef.current);
    } catch (error) {
      console.error('Error clearing interview state:', error);
    }
  };

  const cleanupOldSessions = () => {
    const twoHours = 2 * 60 * 60 * 1000;
    const now = Date.now();
    
    try {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('interviewState_')) {
          try {
            const state = JSON.parse(localStorage.getItem(key));
            if (now - state.timestamp > twoHours) {
              localStorage.removeItem(key);
            }
          } catch (error) {
            localStorage.removeItem(key);
          }
        }
      });
    } catch (error) {
      console.error('Error during cleanup:', error);
    }
  };

  let navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleRepeatQuestion = async (questionText) => {
    if (questionText && !isNoraSpeaking && !isLoading) {
      // Remove the last question and the user's answer to the previous question
      setHistory(prevHistory => {
        // Find the index of the previous question
        const previousQuestionIndex = prevHistory.findIndex(
          msg => msg.role === 'Assistant' && msg.message === questionText
        );
        
        if (previousQuestionIndex !== -1) {
          // Remove everything after and including the user's answer to this question
          // Keep everything up to the previous question
          return prevHistory.slice(0, previousQuestionIndex + 1);
        }
        return prevHistory;
      });
      
      // Reset the question tracking
      setLastNoraQuestion(questionText); // The repeated question becomes current
      setPreviousNoraQuestion(''); // No previous question now
      
      setIsNoraSpeaking(true);
      try {
        await speakTTS(questionText);
      } catch (error) {
        console.error('Error repeating question:', error);
      } finally {
        setIsNoraSpeaking(false);
      }
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: "50vw",
    height: "40vh",
    transform: 'translate(-50%, -50%)',
    bgcolor: '#FAFAFA',
    boxShadow: 24,
    textAlign: 'center',
    overflow: "scroll",
    p: 4,
  };

  const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: isMobile ? "90vw" : "80vw",
    height: isMobile ? "85vh" : "70vh", 
    transform: 'translate(-50%, -50%)',
    bgcolor: '#FAFAFA',
    boxShadow: 24,
    textAlign: 'center',
    overflow: "scroll",
    p: 4,
  };

  const client = new AssemblyAI({
    apiKey: "d1ed33af12ac4d478785ac40bb4599a7"
  });

  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [history]);

  useEffect(() => {
    if (!getToken()) {
      // No token found, redirect to login
      localStorage.clear(); // Clear any stored data
      navigate("/login");
      return;
    }

    const savedState = loadInterviewState();

    if (savedState && savedState.started) {
      setStarted(true);
      setHistory(savedState.history || []);
      setTime(savedState.time || 0);
      setScreenStep(savedState.screenStep || 1);
      setInterviewDone(savedState.isInterviewDone || false);
      setLastNoraQuestion(savedState.lastNoraQuestion || '');
      setPreviousNoraQuestion(savedState.previousNoraQuestion || '');
    }
    // Change body style for mockInterviewerZoom
    document.body.style.backgroundColor = "#FAFAFA";
    
    // Track interview prep page view
    if (window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_name: 'Interview Prep Screen',
        content_category: 'Interview'
      });
    }
    
    // Cleanup function to reset styles when component is unmounted or when navigating away
    return () => {
      document.body.style.backgroundColor = "#FAFAFA";
      clearTimeout(saveTimeoutRef.current);
    };
  }, [navigate]);

  useEffect(() => {
    if (started) {
      debouncedSave({
        started,
        history,
        time,
        screenStep,
        isInterviewDone,
        lastNoraQuestion,
        previousNoraQuestion
      });
    }
  }, [started, history, time, screenStep, isInterviewDone, lastNoraQuestion, previousNoraQuestion]);

  useEffect(() => {
    console.log("aiResponse: ", aiResponse);
  }, [aiResponse]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prevTime => prevTime + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Cleanup preview stream on unmount
  useEffect(() => {
    return () => {
      if (previewStream) {
        previewStream.getTracks().forEach(track => track.stop());
      }
    };
  }, [previewStream]);

  // Auto-start camera when interview starts
  useEffect(() => {
    if (started) {
      const startCamera = async () => {
        try {
          console.log("Auto-starting camera for interview...");
          const stream = await navigator.mediaDevices.getUserMedia({ 
            video: { 
              width: { ideal: 640 }, 
              height: { ideal: 480 } 
            } 
          });
          
          setTimeout(() => {
            if (videoRef.current) {
              videoRef.current.srcObject = stream;
              videoRef.current.onloadedmetadata = () => {
                videoRef.current.play();
              };
            }
          }, 100);
        } catch (err) {
          console.error("Error auto-starting camera:", err);
        }
      };
      startCamera();
    }

    // Cleanup camera on unmount or when interview ends
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
        videoRef.current.srcObject = null;
      }
    };
  }, [started]);

  const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.async = true;
    script.onload = () => {
      console.log('Stripe script loaded successfully');
      setStripeLoaded(true);
    };
    script.onerror = () => {
      console.error('Failed to load Stripe script');
    };
    document.body.appendChild(script);

    return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
    };
  }, []);

  useEffect(() => {
    return () => {
      if (checkout) {
        try {
          checkout.destroy();
        } catch (error) {
          console.warn('Error destroying checkout on cleanup:', error);
        }
      }
    };
  }, [checkout]);

  const initializeEmbeddedCheckout = async (plan) => {
    if (!stripeLoaded || !window.Stripe) {
      console.error('Stripe not loaded yet');
      setCheckoutError('Stripe is still loading. Please try again in a moment.');
      return;
    }
    if (!stripePublishableKey) {
      console.error('Missing publishable Stripe key');
      setCheckoutError('Payment configuration is incomplete. Please contact support.');
      return;
    }

    try {
      setCheckoutError('');
      setIsCheckoutLoading(true);

      if (!userEmail) throw new Error('Missing user email for checkout session.');

      const stripe = window.Stripe(stripePublishableKey);

      // Note: Cleanup is now handled in handleUpgrade to avoid double cleanup

      const fetchClientSecret = async () => {
        // Use specific price IDs for both plans
        const priceId = plan === 'annual' 
          ? 'price_1S8GAZ007XiUv8ECfnqj7tsI'  // $99/year
          : 'price_1PtG3P007XiUv8ECG0fSdL6h';  // $14.99/month
        const payload = { email: userEmail, priceId };
        
        console.log(`Creating checkout session for ${plan} plan:`);
        console.log('Payload being sent:', JSON.stringify(payload, null, 2));
        
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/payments/create-embedded-checkout-session`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(payload),
          }
        );
        
        console.log('Response status:', response.status);
        console.log('Response headers:', response.headers);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Backend error response:', errorText);
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }
        
        const responseData = await response.json();
        console.log('Backend response:', responseData);
        const { clientSecret } = responseData;
        
        if (!clientSecret) {
          throw new Error('No clientSecret received from backend');
        }
        
        return clientSecret;
      };

      const embeddedCheckout = await stripe.initEmbeddedCheckout({ fetchClientSecret });
      embeddedCheckout.mount('#checkout');
      setCheckout(embeddedCheckout);
    } catch (error) {
      console.error('Error initializing embedded checkout:', error);
      setCheckoutError('We could not start the payment flow. Please try again or contact support.');
    } finally {
      setIsCheckoutLoading(false);
    }
  };

  const handleUpgrade = async (plan) => {
    // Clean up any existing checkout first
    if (checkout) {
      try {
        checkout.destroy();
      } catch (error) {
        console.warn('Error destroying previous checkout:', error);
      }
      setCheckout(null);
    }
    
    // Clear the checkout container
    const checkoutContainer = document.getElementById('checkout');
    if (checkoutContainer) {
      checkoutContainer.innerHTML = '';
    }
    
    // Set the selected plan
    setSelectedPlan(plan);
    
    // Wait a moment for cleanup, then initialize new checkout
    await new Promise(resolve => setTimeout(resolve, 200));
    await initializeEmbeddedCheckout(plan);
  };

  const animationContainer = useRef(null);

  useEffect(() => {
    const lottie = window.lottie;
    const animationData = screenStep === 3
    ? isMobile
      ? require('../../images/homepage/mobile-end-interview-animation.json')
      : require('../../images/homepage/end-Interview-Animation.json')
    : isMobile
      ? require('../../images/homepage/mobile-answering-animation.json')
      : require('../../images/homepage/Start-Stop-Answering-Animation-audio-waves.json');

    lottie.loadAnimation({
      container: animationContainer.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
    });

    return () => {
      lottie.destroy();
    };
  }, [screenStep]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}m ${s < 10 ? '0' : ''}${s}sec`;
  };

  const startRecording = () => {
    setRecord(true);
  };

  const stopRecording = () => {
    setRecord(false);
  };

  const onBackClick = () => {
    if (started) {
      // If interview has started, show confirmation modal
      setShowLeaveModal(true);
    } else if (testing) {
      stopPreviewStream();
      setTesting(false);
    } else {
      navigate("/mockInterviewerInput");
      window.location.reload();
    }
  };

  const handleLeaveAnyway = async () => {
    setShowLeaveModal(false);
    
    // Clean up Daily.co if active
    if (isDailyRecording) {
      await stopDailyRecording();
    }
    await leaveDailyRoom();
    
    // Clean up camera
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      videoRef.current.srcObject = null;
    }
    
    clearInterviewState(); 
    navigate("/mockInterviewerInput");
    window.location.reload();
  };

  const handleStayInInterview = () => {
    setShowLeaveModal(false);
  };

  //This will retry the API twice if it fails for some reason in the first time
  const retryRequest = async (fn, retries = 2, interval = 1000) => {
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        setHasError(false);
        return await fn();
      } catch (error) {
        if (attempt < retries - 1) {
          await new Promise(resolve => setTimeout(resolve, interval));
        } else {
          Sentry.captureException(error, {
            extra: {
              message: "Retry function failed",
              email: userEmail,
              retriesAttempted: retries,
              intervalBetweenRetries: interval,
              lastError: error.message, 
            },
          });
          setHasError(true);
          throw error;
        }
      }
    }
  };

  const handleAnswerForMe = async () => {
    if (!lastNoraQuestion || isLoading || isNoraSpeaking || record) return;
    
    setIsLoading(true);
    setHasError(false);
    
    try {
      const formData = new FormData();
      formData.append('question', lastNoraQuestion);
      formData.append('position', position);
      formData.append('jobDescription', jobDescription);
      formData.append('CompanyName', companyName);
      formData.append('TechnicalLevel', technicalLevel);
      
      const resumeDataUrl = localStorage.getItem("resume");
      if (resumeDataUrl) {
        const base64String = resumeDataUrl.split(',')[1];
        const mimeType = resumeDataUrl.split(',')[0].split(':')[1].split(';')[0];
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: mimeType });
        formData.append('resume', file);
      }
      
      formData.append('History', JSON.stringify(history));

      const response = await retryRequest(() =>
        axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/answerForMe`, formData, {
          headers: { 
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${getToken()}`
          },
        })
      );

      const generatedAnswer = response.data.answer;
      
      // Feed it through the normal flow as if the user said it
      await handleSendMessage(generatedAnswer);
    } catch (error) {
      console.error('Answer for me failed:', error);
      setHasError(true);
      setIsLoading(false);
    }
  };

  const handleEndInterview = async () => {
    // Stop camera
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      videoRef.current.srcObject = null;
    }
  
    setFeedbackLoading(true);
    setOpenErrorModal(false);

    // DAILY.CO: Stop recording then hand off to server
    const recordingRoomName = roomInfo?.roomName || null;
    try {
      if (isDailyRecording) await stopDailyRecording();
    } catch (err) {
      console.error('Failed to trigger recording processing:', err);
    }

    // Clean up Daily room
    await leaveDailyRoom();
    
    const resumeDataUrl = localStorage.getItem("resume");
    const resumeFileName = localStorage.getItem("resumeFileName");
    var file = new Blob();
  
    if (resumeDataUrl) {
      const base64String = resumeDataUrl.split(',')[1];
      const mimeType = resumeDataUrl.split(',')[0].split(':')[1].split(';')[0];
  
      // Create a Blob from the Base64 string
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      file = new Blob([byteArray], { type: mimeType });
    }
  
    const finalHistory = [...history, { role: 'User', message: "last" }];
    setHistory(finalHistory);
  
    try {
      const isSalaryNegotiation = technicalLevel == 15;
      const endpoint = isSalaryNegotiation 
        ? `${process.env.REACT_APP_API_ENDPOINT}/Chat/generateSalaryNegotiationFeedback`
        : `${process.env.REACT_APP_API_ENDPOINT}/Chat/generateFeedback`;

      const formData = new FormData();
      formData.append('Position', position);
      formData.append('JobDescription', jobDescription);
      formData.append('History', JSON.stringify(finalHistory));
      formData.append('CompanyName', companyName);
      formData.append('InterviewTime', formatTime(time));
      formData.append('Resume', file);
      formData.append('ResumeFileName', resumeFileName || 'resume.pdf');
      formData.append('TechnicalLevel', technicalLevel);
      formData.append('AudioRecordingUrl', '');

      if (isSalaryNegotiation) {
        formData.append('SalaryRange', salaryRange || '');
        formData.append('Location', location || '');
      }

      const response = await retryRequest(() =>
        axios.post(endpoint, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'text/plain',
            Authorization: `Bearer ${getToken()}`,
          },
        })
      );

      const aiResponse = response.data.feedback;
      const interviewId = response.data.interviewId;
      const timerFeedback = formatTime(time);

      // Fire and forget — server handles polling, S3 upload, DB persist
      if (recordingRoomName) {
        axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/Daily/processRecordingAsync`,
          { roomName: recordingRoomName, interviewId: interviewId },
          { headers: { Authorization: `Bearer ${getToken()}` } }
        ).catch(() => {});
      }
      
      clearInterviewState();
      setFeedbackLoading(false);
      
      navigate("/mockInterviewerFeedback", { 
        state: { 
          aiResponse, 
          history: finalHistory, 
          timerFeedback, 
          technicalLevel, 
          fromInputScreen: false,
          recordingRoomName // feedback screen polls using this
        } 
      });

    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          email: userEmail,
          JobDescription: jobDescription,
          History: JSON.stringify(finalHistory),
          CompanyName: companyName,
        },
      });
      console.error('Error generating feedback:', error);
      setFeedbackLoading(false);
      setOpenErrorModal(true);
    }
  };

  const onStop = (recordedBlob) => {
    const reader = new FileReader();
    reader.readAsDataURL(recordedBlob.blob);
    setHasError(false);

    assemblySpeechToText(recordedBlob.blob).catch((err) => {
      console.warn("Transcription failed:", err);
      setIsLoading(false);
      setHasError(true); 
    });
  };

  const assemblySpeechToText = async (audioBlob) => {
    setIsLoading(true);
    try {
      const transcript = await retryRequest(() =>
        client.transcripts.transcribe({ audio: audioBlob })
      );
      if (transcript.status === 'error') {
        throw new Error(transcript.error || 'Transcription error');
      }
      await handleSendMessage(transcript.text);
    } finally {
      setIsLoading(false);
    }
  };

  async function speakTTS(text) {
    try {
      const resp = await retryRequest(() =>
        axios.post(
          `${process.env.REACT_APP_API_ENDPOINT}/Chat/textToSpeech`,
          { text },
          { responseType: "blob" },
        ),
      );
      if (resp.status === 200) {
        const blob = new Blob([resp.data], { type: "audio/wav" });
        
        // If Daily recording is active, route audio through the audio graph
        if (isDailyRecording && audioContextRef.current && noraAudioRef.current) {
          await playNoraTTSBlob(blob);
        } else {
          // Fallback to simple audio playback
          const audio = new Audio(URL.createObjectURL(blob));
          await new Promise((res) => {
            audio.onended = res;
            audio.play();
          });
        }
      }
    } catch (e) {
      console.warn("TTS failed:", e);
    }
  }

  // New function to play TTS through Daily audio graph (so Nora voice is in recording)
  const playNoraTTSBlob = async (blob) => {
    try {
      await initNoraAudioGraph();

      const url = URL.createObjectURL(blob);
      const el = noraAudioRef.current;
      
      try { el.pause(); } catch {}
      el.currentTime = 0;
      el.volume = 1.0; 
      el.src = url;
      
      setIsNoraSpeaking(true);
      
      await el.play();
      
      return new Promise((resolve) => {
        el.onended = el.onerror = () => {
          setIsNoraSpeaking(false);
          URL.revokeObjectURL(url);
          resolve();
        };
      });
    } catch (err) {
      console.warn('playNoraTTSBlob error:', err);
      // Fallback to simple audio
      const audio = new Audio(URL.createObjectURL(blob));
      setIsNoraSpeaking(true);
      await new Promise((res) => {
        audio.onended = () => {
          setIsNoraSpeaking(false);
          res();
        };
        audio.play();
      });
    }
  };

  const handleSendMessage = async (transcription) => {
    setHasError(false);
    const formData = new FormData();

    const resumeDataUrl = localStorage.getItem("resume");

    if (resumeDataUrl) {
      const base64String = resumeDataUrl.split(',')[1];
      const mimeType = resumeDataUrl.split(',')[0].split(':')[1].split(';')[0];

      // Create a Blob from the Base64 string
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const file = new Blob([byteArray], { type: mimeType });

      formData.append('resume', file);
    }

    formData.append('position', position);
    formData.append('jobDescription', jobDescription);
    formData.append('UserMessage', transcription);
    formData.append('CompanyName', companyName);
    formData.append('TechnicalLevel', technicalLevel);

    if (companyData) {
      formData.append('CompanyData', companyData);
    }

    // Combine salary range with currency if in salary negotiation mode
    if (technicalLevel === 15) {
        const combinedSalary = `${currency} ${salaryRange}`;
        formData.append('salaryRange', combinedSalary);
        formData.append('location', location);
    }

    setHistory(prevHistory => {
      const newHistory = [...prevHistory, { role: 'User', message: transcription }];    
      formData.append('History', JSON.stringify(newHistory));
      return newHistory;
    });

    try {
      const response = await retryRequest(() => axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/nora`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }));
      const { response: aiResponse } = response.data;


      if (aiResponse.toLowerCase().includes("end of the interview") ) {
        const closingLines = [
          "Thanks for taking the time to chat with me today.",
          "We'll be in touch soon.",
        ];

        for (const line of closingLines) {
          setHistory((h) => [...h, { role: "Assistant", message: line }]);
          await new Promise((r) => setTimeout(r, 100)); 
          await speakTTS(line);
          await new Promise((r) => setTimeout(r, 300));
        }

        setInterviewDone(true);
        await handleEndInterview();
        return;
      }

      setAiResponse(aiResponse);

      // Wait for React to update the DOM and text to render
      await new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            resolve();
          });
        });
      });

      // Then convert to speech and play audio
      const audioResponse = await retryRequest(() => axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/textToSpeech`, {
        text: aiResponse
      }, {
        responseType: 'blob'
      }));

      if (audioResponse.status === 200) {
        const audioBlob = new Blob([audioResponse.data], { type: 'audio/wav' });

        setHistory(prevHistory => {
          const newHistory = [...prevHistory, { role: 'Assistant', message: aiResponse }];
          setPreviousNoraQuestion(lastNoraQuestion);
          setLastNoraQuestion(aiResponse);
          return newHistory;
        });
        
        // Route through Daily audio graph if recording
        if (isDailyRecording && audioContextRef.current) {
          setIsNoraSpeaking(true);
          await playNoraTTSBlob(audioBlob);
        } else {
          const audioUrl = URL.createObjectURL(audioBlob);
          const audio = new Audio(audioUrl);
          setIsNoraSpeaking(true);
          audio.play();
          audio.onended = () => {
            setIsNoraSpeaking(false);
          };
        }
        
      } else {
        setHasError(true);
        console.error('Failed to convert text to speech');
      }

 
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          email: userEmail,
          JobDescription: jobDescription,
          History: JSON.stringify(history),
          CompanyName: companyName,
        },
      });
      setHasError(true);
      console.error('Error sending message:', error);
    }
    setIsLoading(false);
  };  

  const startInterview = async () => {
    const deviceType = getDeviceType();
     
    if (deviceType === 'mobile' || deviceType === 'tablet' || isIPad || isMobile) {
      setShowMobileWarningModal(true);
      return;
    }

    // Move to testing screen and check permissions
    setTesting(true);
    
    try {
      await checkPermissions();
      console.log('✅ Preview permissions checked');
    } catch (error) {
      console.error('Error checking permissions on start:', error);
    }
  };

  const proceedToActualInterview = async () => {
    if (!audioPermissionGranted || !videoPermissionGranted) {
      setPermissionError('Both camera and microphone access are required to start the interview.');
      return;
    }

    // Stop the preview stream before starting the interview
    stopPreviewStream();

    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Mock Interview Started',
        content_category: 'Interview'
      });
    }
    
    setTesting(false);
    setStarted(true);
    setIsLoading(true);

    // DAILY.CO: Create room and start recording
    try {
      const room = await createDailyRoom();
      setRoomInfo(room);
      await joinDailyRoom(room.roomUrl);
      await startDailyRecording();
      console.log('✅ Daily recording started for mock interview');
    } catch (err) {
      console.error('Failed to start Daily recording:', err);
      // Continue interview even if recording fails
    }

    handleSendMessage("first");
  };

  const nextButton = () => {
    setScreenStep(prevStep => prevStep + 1);
  };

  return (
    <div>
      {started && (
        <div className="interview-title2">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img src={LeftArrow} onClick={onBackClick} className="left-arrow-styling2" />
            <div>
              {technicalLevel == 15 
                ? `Mock Salary Negotiation with Nora for ${position}` 
                : `Mock Interview with Nora for ${position}`
              }              
            </div>
          </div>
        </div>
      )}
      {showLeaveModal && (
        <div className="leaveInterviewOverlay">
          <div className="leaveInterviewContent">
            <button 
              className="close-modal-btn"
              onClick={handleStayInInterview}
              aria-label="Close modal"
            >
              ×
            </button>
            
            <div className="leave-modal-icon">
              <img src={ExclamationIcon} alt="Warning" />
            </div>
            
            <h2>Leave Interview?</h2>
            <p>You are currently in the middle of a mock interview. If you go back now, your progress will be lost.</p>
            
            <div className="leave-modal-buttons">
              <button onClick={handleLeaveAnyway} className="nora-button4-style">
                Leave Anyway
              </button>
              <button onClick={handleStayInInterview} className="nora-button5-style">
                Stay in Interview
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="nora-form-3" style={isMobile && !started && !testing ? {flexDirection: 'row'} : {}}>
        {testing ? (
          // TESTING SCREEN
          <div className="testing-screen2">
            <div className="testing-card">
              <div className="instruction-container2">
                <h1 style={{ marginBottom: '10px', textAlign: 'center' }}>Video and Audio check</h1>
                <p style={{ textAlign: 'center', width: '100%' }}>Before you start, make sure your video and audio are set up properly.</p>
              </div>

              <div className="testing-body">
                {/* VIDEO SETTINGS COLUMN */}
                <div className="testing-column">
                  <div className="section-header">
                      <img src={VideoRecorderIcon} alt="Video" className="section-icon" />
                      <span className="section-title2">Video Settings</span>
                  </div>

                  <div className="video-preview-row">
                    <div className="video-preview-card">
                      <video
                        ref={previewVideoRef}
                        autoPlay
                        muted
                        playsInline
                        className="preview-video"
                        style={{ transform: 'scaleX(-1)' }}
                      />
                    </div>

                    <div className="video-copy">
                      {permissionError ? (
                        <>
                          <h3>Your camera is currently off.</h3>
                          <p>
                            Please enable it to check your framing and lighting before the interview.
                          </p>
                        </>
                      ) : (
                        <>
                          <h3>Smile, you're on camera!</h3>
                          <p>
                            Center yourself in the frame to make sure Nora
                            can see you clearly.
                          </p>
                        </>
                      )}
                  </div>
                  
                </div>

                  <div className="field-group">
                    <label className="field-label" style={{ textAlign: 'left', display: 'block' }}>Camera</label>
                    <div className="select-wrapper">
                      <select 
                        className="field-select" 
                        value={selectedVideoDeviceId}
                        onChange={(e) => handleDeviceChange(e.target.value, 'video')}
                      >
                        {availableVideoDevices.length === 0 ? (
                          <option value="">Default camera</option>
                        ) : (
                          availableVideoDevices.map(device => (
                            <option key={device.deviceId} value={device.deviceId}>
                              {device.label || `Camera ${device.deviceId.slice(0, 8)}...`}
                            </option>
                          ))
                        )}
                      </select>
                    </div>
                  </div>

                  {showPermissionsModal && (
                    <div className="permissions-modal-overlay" onClick={() => setShowPermissionsModal(false)}>
                      <div className="permissions-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="permissions-modal-header">
                          <div>
                            <h2>Enable Camera & Microphone Permissions</h2>
                            <p>Follow these steps to allow access to your camera and microphone.</p>
                          </div>
                          <button type="button" className="modal-close" onClick={() => setShowPermissionsModal(false)}>
                            &times;
                          </button>
                        </div>

                        <div className="permissions-modal-tabs">
                          {['chrome', 'safari'].map(tab => (
                            <button
                              key={tab}
                              type="button"
                              className={`permissions-tab ${permissionsBrowserTab === tab ? 'active' : ''}`}
                              onClick={() => setPermissionsBrowserTab(tab)}
                            >
                              {tab === 'chrome' ? 'Chrome' : 'Safari'}
                            </button>
                          ))}
                        </div>

                        <div className="permissions-modal-body">
                          <div className="permissions-callout">
                            <span>ℹ️</span>
                            <p>{permissionsGuides[permissionsBrowserTab].title}</p>
                          </div>

                          {permissionsGuides[permissionsBrowserTab].sections.map(section => (
                            <div key={section.heading} className="permissions-section">
                              <h3>{section.heading}</h3>
                              <ol>
                                {section.steps.map(step => (
                                  <li style={{textAlign: 'left'}} key={step}>{step}</li>
                                ))}
                              </ol>
                            </div>
                          ))}

                          <div className="permissions-callout muted">
                            <span>⚠️</span>
                            <p>{permissionsGuides[permissionsBrowserTab].footer}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* AUDIO SETTINGS COLUMN */}
                <div className="testing-column">
                  <div className="section-header">
                      <img src={AudioRecorderIcon} alt="Audio" className="section-icon" />
                      <span className="section-title2">Audio Settings</span>
                  </div>

                  <div className="field-group">
                    <label className="field-label" style={{ textAlign: 'left', display: 'block' }}>Microphone</label>
                    <div className="select-wrapper">
                      <select 
                        className="field-select" 
                        value={selectedAudioDeviceId}
                        onChange={(e) => handleDeviceChange(e.target.value, 'audio')}
                      >
                        {availableAudioDevices.length === 0 ? (
                          <option value="">{audioPermissionGranted ? "Default microphone" : "Select microphone"}</option>
                        ) : (
                          availableAudioDevices.map(device => (
                            <option key={device.deviceId} value={device.deviceId}>
                              {device.label || `Microphone ${device.deviceId.slice(0, 8)}...`}
                            </option>
                          ))
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="field-group">
                    <div className="field-label-row">
                      <label className="field-label">Input level</label>
                    </div>
                    <div className="input-level-row">
                      <ReactMic
                        record={permissionsReady && testing}
                        className="input-level-bar mic-bar-visual"
                        onStop={() => {}}
                        visualSetting="frequencyBars"
                        strokeColor="#4CAF50"
                        backgroundColor="#f5f5f5"
                        echoCancellation={true}
                        autoGainControl={true}
                        noiseSuppression={true}
                        style={{
                          width: '100%',
                          height: '32px',
                          borderRadius: '12px',
                          overflow: 'hidden'
                        }}
                      />
                    </div>
                  </div>

                  {permissionError && (
                    <div className="permission-error testing-permission-error">
                      <img src={ErrorIcon} alt="Error Icon" className="error-icon" />
                      <span>{permissionError}</span>
                    </div>
                  )}

                  {!permissionsReady && (
                    <div className="tip-box tip-warning">
                      <div className="tip-warning-row">
                        <span className="tip-warning-icon">⚠️</span>
                        <p>
                          This interview requires your camera and microphone to be enabled.
                          <button type="button" className="learn-link" onClick={() => setShowPermissionsModal(true)}>
                            Learn here
                          </button>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="testing-footer">
                <button 
                  onClick={() => { stopPreviewStream(); setTesting(false); }}
                  className="testing-btn testing-btn-secondary"
                  type="button"
                >
                  Back
                </button>
                <button 
                  onClick={proceedToActualInterview} 
                  className="start-button2"
                  type="button"
                  disabled={!permissionsReady}
                >
                  Start Interview
                </button>
              </div>
            </div>
          </div>
        ) : !started ? (
        <div className="instructionsImage2">

          {technicalLevel == 15 ? (
            <div className="instruction-container2">
              <h1>Welcome to your Salary Negotiation Practice with Nora</h1>
              <p>Mock Salary negotiation practice for the {position} position. Approximately 5-10 exchanges and will last around 10-15 minutes.<br /></p>
            </div>
          ) : (
            <div className="instruction-container2">
              <h1>Welcome to your Mock Interview with Nora</h1>
              <p>Mock interview for the {position} position. Approximately 10 questions and will last around 20 minutes.<br /></p>
            </div>
          )}
          
          <div className="demo-link">
              <p>Some tips before you begin</p>
          </div>

          <div className="instruction-cards">
            <div className="instruction-card1">
              <img src={InterviewCard1} alt="Interview Tutorial icon" />
              <div className="instruction-card-title">First time mock interviewing with Nora, our <strong> AI Interviewer? </strong></div>
              <a href="https://youtu.be/dS3S4kLVpRo?si=m-U7kPbr6UKhDKl4" target="_blank" rel="noopener noreferrer" className="watch-tutorial-button">
                Watch our Tutorial
              </a>
            </div>

            <div className="instruction-card">
              <img src={InterviewCard2} alt="Chrome icon" />
              <div className="instruction-card-title">For the best experience, use a <strong> Laptop & Google Chrome. </strong></div>
            </div>
            
            <div className="instruction-card">
              <img src={InterviewCard3} alt="Quiet environment icon" />
              <div className="instruction-card-title">Ensure you are in a <strong> quiet, noise-free </strong> environment.</div>
            </div>
            
            <div className="instruction-card">
              <img src={InterviewCard4} alt="Microphone icon" />
              <div className="instruction-card-title">Ensure sure your <strong> audio & video permissions are enabled </strong> by the browser.</div>
            </div>
          </div>

          <div className="interview-ready-section">
            {!isMobile && (
              <div className="ready-text">Are you ready?</div>
            )}

            <button onClick={startInterview} className="start-button2">Start Interview</button>
          </div>
        </div>
        ) : (
          <>
            {feedbackLoading && <FeedbackLoader />}

            <Modal onClose={() => setOpenTest(false)} open={openTest} disableBackdropClick={true} disableEscapeKeyDown={true}>
              <Box className="custom-modal-box" sx={style2}>
            <h2 className="pricing-title">Want to access your feedback?</h2>
            <p className="pricing-subtitle">
   
              <span className="pricing-subtext">Subscribe and unlock all your interview insights with Nora</span>
            </p>


            {checkout && (
              <button 
                className="pricing-back-btn" 
                onClick={() => {
                  if (checkout) {
                    checkout.destroy();
                    setCheckout(null);
                    setCheckoutError('');
                  }
                }}
                aria-label="Go back to plan selection"
              >
                ← Back to Plans
              </button>
            )}

            {!checkout && (
              <div className="pricing-grid">
              <div className={`pricing-card ${selectedPlan === 'monthly' ? 'featured' : ''}`}>
                <div className="pricing-card__icon"><AutoFixHighIcon /></div>
                <div className="pricing-card__name">Actually Get Better</div>
                <div className="pricing-card__separator"></div>
                <div className="pricing-card__price">
                  <span className="pricing-amount">$15</span><span className="pricing-period">/mo</span>
                </div>
                <div className="pricing-card__desc">Best for consistent practice & growth.</div>
                <ul className="pricing-list">
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Unlimited mock interviews</li>
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Complete Nora feedback</li>
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Interactive AI coaching chat</li>
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Detailed question analysis</li>
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Personalised action plan</li>
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Cancel your subscription anytime</li>
                </ul>
                <button
                  className="pricing-btn solid pricing-btn--monthly"
                  onClick={() => handleUpgrade('monthly')}
                  disabled={isCheckoutLoading}
                >
                  {isCheckoutLoading && selectedPlan === 'monthly' ? 'Starting…' : 'Upgrade Now'}
                </button>
              </div>

              <div className={`pricing-card ${selectedPlan === 'annual' ? 'featured' : ''}`}>
                <div className="pricing-card__top-line">
                  <div className="pricing-card__icon"><FlashOnIcon /></div>
                  <div className="pricing-reco-badge">Recommended</div>
                </div>
                <div className="pricing-card__name">Best Value</div>
                <div className="pricing-card__separator"></div>
                <div className="pricing-card__price">
                  <span className="pricing-amount">$99</span><span className="pricing-period">/yr</span>
                </div>
                <div className="pricing-card__desc">Everything you need to level up, at the best price.</div>
                <ul className="pricing-list">
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Everything in Pro Monthly</li>
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Save over $80/year</li>
                  <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Stay motivated with long-term growth</li>
                </ul>
                <button
                  className="pricing-btn solid pricing-btn--annual"
                  onClick={() => handleUpgrade('annual')}
                  disabled={isCheckoutLoading}
                >
                  {isCheckoutLoading && selectedPlan === 'annual' ? 'Starting…' : 'Upgrade Now'}
                </button>
              </div>
            </div>
            )}

            <div
              id="checkout"
              style={{
                display: checkout ? 'block' : 'none',
                minHeight: checkout ? 500 : 0,
                width: '100%',
                marginTop: checkout ? 16 : 0
              }}
            />

            {checkoutError && (
              <div className="pricing-error">{checkoutError}</div>
            )}

              </Box>  
            </Modal>

            {showEndModal && (
              <div className="endInterviewOverlay">
                <div className="endInterviewContent">
                  <h2>Are you sure you want to end this interview?</h2>
                  <div className="modal-buttons">
                    <button onClick={handleConfirmEnd} className="modal-confirm-button">Yes, Stop</button>
                    <button onClick={handleCancelEnd} className="modal-cancel-button">No, Resume</button>
                  </div>
                </div>
              </div>
            )}

            <div className="video-section">
              <div className="header-controls">
                <div className="nora-timer2">
                  <div>{formatTime(time)}</div>
                </div>
              </div>
              
              <div className="user-video-container">
                <video 
                  ref={videoRef} 
                  autoPlay 
                  muted
                  className="user-video-feed"
                />
              </div>
              
              {(!isLoading && !isNoraSpeaking && !isInterviewDone) && (
                <div className="video-mic-container2">
                  <ReactMic
                    record={record}
                    className="mic-styling2"
                    onStop={onStop}
                    visualSetting="frequencyBars" />
                </div>
              )}
            </div>

            <div className="transcript-container">
              <div className="transcript-label">Live Transcript</div>
              <div className="transcript-divider"></div>
              <div className="message-history">
                {history.map((msg, index) => (
                  msg.message !== "first" && msg.message !== "last" && (
                    <div key={index} className={`message ${msg.role}`}>
                      {msg.message}
                      {msg.role === 'Assistant' && 
                        msg.message === previousNoraQuestion &&
                        previousNoraQuestion &&
                        !isLoading && 
                        !isNoraSpeaking && 
                        !isInterviewDone && (
                          <button 
                            className="repeat-question-btn"
                            onClick={() => handleRepeatQuestion(previousNoraQuestion)}
                            title="Repeat this question"
                          >
                            ↻
                          </button>
                      )}
                    </div>
                  )
                ))}
                {hasError && (
                    <div className="error-message">
                        <img src={ErrorIcon} alt="Error Icon" className="error-icon" />
                        <span>Oops, we couldn't capture your speech. Please try recording again.</span>
                    </div>
                )}
                <Modal onClose={() => setOpenErrorModal(false)} open={openErrorModal}>
                  <Box sx={style}>
                      <button className="close-button" onClick={() => setOpenErrorModal(false)}>X</button>
                      <div className="error-message-modal">
                          <img src={ErrorIcon} alt="Error Icon" className="error-icon-modal" />
                          <h2>Oops!</h2>
                          <p>We couldn't generate feedback. Please hit 'End Interview' button again. <strong> Still stuck? </strong>Reach out to us at <a href="mailto:hannan@norahq.com">hannan@norahq.com</a> for assistance.</p>
                      </div>
                  </Box>
                </Modal>
                {isLoading && (
                  <div className="">
                    <Oval color="#00BFFF" height={20} width={20} />
                    <span>Nora is thinking...</span>
                  </div>
                )}
                <div ref={messageEndRef} />
              </div>
            </div>
          </>
        )}
      </div>

      {started && (
      <div className="interview-controls2">
        <div className="interview-controls-left">
          <button 
            disabled={(!record && (isLoading || isNoraSpeaking || isInterviewDone))} 
            onClick={record ? stopRecording : startRecording}
            type="button"
            className={`startAnsweringBtn ${record ? 'stop-recording' : ''} ${(!record && (isLoading || isNoraSpeaking || isInterviewDone)) ? 'disabled' : ''}`}
          >
            {record ? 'Stop Answering' : 'Start Answering'}
          </button>

          {!record && !isLoading && !isNoraSpeaking && !isInterviewDone && lastNoraQuestion && !isMobile && (
            <button 
              onClick={handleAnswerForMe}
              type="button"
              className={`startAnsweringBtn ${record ? 'stop-recording' : ''} ${(!record && (isLoading || isNoraSpeaking || isInterviewDone)) ? 'disabled' : ''}`}
            >
              Answer for Me
            </button>
          )}
        </div>

        <button onClick={handleEndInterviewClick} type="button" className="endInterviewBtn2">End Interview</button>
      </div>
    )}
      
      {showMobileWarningModal && (
        <div className="leaveInterviewOverlay">
          <div className="leaveInterviewContent">
            <button 
              className="close-modal-btn"
              onClick={() => setShowMobileWarningModal(false)}
              aria-label="Close modal"
            >
              ×
            </button>
            
            <div className="leave-modal-icon">
              <img src={ExclamationIcon} alt="Warning" />
            </div>
            
            <h2>Device Not Supported</h2>
            <p>Nora is not mobile friendly. Please take this mock interview on a laptop AND Chrome for the best experience.</p>
            
            <div className="leave-modal-buttons">
              <button 
                onClick={() => setShowMobileWarningModal(false)} 
                className="nora-button5-style"
              >
                Understood
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoraForm;
